import { combineSlices } from '@reduxjs/toolkit';
import { dmAdminApiSlice } from '@vs/rtk/slices/apiDmAdmin';
import { vsAccount2ApiSlice } from '@vs/rtk/slices/apiVsAccount2';
import { vsAdminApiSlice } from '@vs/rtk/slices/apiVsAdmin';
import { vsAuthApiSlice } from '@vs/rtk/slices/apiVsAuth';
import { vsAuthAdminApiSlice } from '@vs/rtk/slices/apiVsAuthAdmin';
import { vsCommonApiSlice } from '@vs/rtk/slices/apiVsCommon';
import { vsEntity2ApiSlice } from '@vs/rtk/slices/apiVsEntity2';
import { vsSubscriptionApiSlice } from '@vs/rtk/slices/apiVsSubscription';
import { generalStateSlice } from '@vs/rtk/slices/genericGlobal';

import { globalSlice } from './slices/global';

export const rootReducer = combineSlices(
  generalStateSlice,
  globalSlice,
  vsAccount2ApiSlice,
  vsEntity2ApiSlice,
  vsAdminApiSlice,
  vsCommonApiSlice,
  vsAuthAdminApiSlice,
  vsSubscriptionApiSlice,
  dmAdminApiSlice,
  vsAuthApiSlice
);
